export default __webpack_public_path__ + "static/media/4404426_1.33a64fb3.png";